import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative w-screen h-screen" }
const _hoisted_2 = { class: "absolute bottom-32 right-4 md:right-12" }
const _hoisted_3 = { class: "absolute top-4 w-full w-full md:w-3/12 grid grid-cols-12" }
const _hoisted_4 = { class: "grid md:grid-cols-3 grid-cols-2" }
const _hoisted_5 = { class: "max-h-[600px] h-auto overflow-y-auto mt-4" }
const _hoisted_6 = { class: "w-full h-full pb-4 overflow-y-auto flex flex-col space-y-16" }
const _hoisted_7 = { class: "flex flex-col space-y-4" }
const _hoisted_8 = { class: "flex flex-col space-y-4" }
const _hoisted_9 = { class: "flex flex-col space-y-4" }
const _hoisted_10 = { class: "w-full flex flex-col space-y-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "max-h-[600px] h-auto overflow-y-auto mt-4" }

import WorldMapSvg from "@/components/WorldMapSvg.vue";
import ThemeButtonMenu from "@/components/Menus/ThemeButtonMenu.vue";
import { computed, ref } from "vue";
import MapCaseForMenu from "@/components/Menus/MapCaseForMenu.vue";
import { useMapThemeStore } from "@/store/useMapThemeStore";
import { useAuthStore } from "@/store/useAuthStore";
import { useDialogsStore } from "@/store/useDialogsStore";
import SearchButtonMenu from "@/components/Menus/SearchButtonMenu.vue";
import LeftButtonMenu from "@/components/Menus/LeftButtonMenu.vue";
import BottomSheet from "@/components/Menus/BottomSheet.vue";
import { useCountriesStore } from "@/store/useCountriesStore";
import StatsButtonMenuContainer from "@/components/Menus/StatsButtonMenuContainer.vue";
import CountryListMenu from "@/components/Menus/CountryListMenu.vue";
import PaletteMenu from "@/components/Menus/PaletteMenu.vue";
import { useMapStore } from "@/store/useMapStore";
import SideBar from "@/components/Menus/SideBar.vue";
import UserManageView from "@/components/Friends/UserManageView.vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import UserManageViewContainer from "@/components/Friends/UserManageViewContainer.vue";
import UserAddViewContainer from "@/components/Friends/UserAddViewContainer.vue";
import UserNotificationsViewContainer from "@/components/Friends/UserNotificationsViewContainer.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";
import { $ } from "vue/macros";
import InputText from "@/components/Form/InputText.vue";
import ButtonSecondary from "@/components/Buttons/ButtonSecondary.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'WorldMapView',
  setup(__props) {

const dialogsStore = useDialogsStore();
const countriesStore = useCountriesStore();
const authStore = useAuthStore();
const friendsStore = useFriendsStore();

const themeColorMenu = dialogsStore.createNewDialog();
const statsMenu = dialogsStore.createNewDialog();
const friendsMenu = dialogsStore.createNewDialog();
const searchMenu = dialogsStore.createNewDialog();

const openThemeColorMenu = () => {
  dialogsStore.openModal(themeColorMenu);
};

const openStatsMenu = () => {
  dialogsStore.openModal(statsMenu);
};

const openFriendsMenu = () => {
  dialogsStore.openModal(friendsMenu);
};

const openSearchMenu = () => {
  dialogsStore.openModal(searchMenu);
};

const mapThemeStore = useMapThemeStore();
const themes = mapThemeStore.themes;
const themeSelected = computed(() => {
  return authStore.currentUser?.selectedTheme;
});

const updateThemeSelected = (name: string) => {
  authStore.updateTheme(name);
};

const mapStore = useMapStore();

const allContinents = mapStore.getAllContinents();
const dialogsContinent: { continent: string; dialog: number }[] = [];

for (const country of countriesStore.countries) {
  const continent = country.continent;

  const existingDialog = dialogsContinent.find(
    (info) => info.continent === continent
  );

  if (!existingDialog) {
    dialogsContinent.push({
      continent,
      dialog: dialogsStore.createNewDialog(),
    });
  }
}

const downloadSvg = () => {
  const svgElement = document.getElementById("worldMap");

  const transform = svgElement.style.transform;

  svgElement.style.transform = "none";

  const svgContent = new XMLSerializer().serializeToString(svgElement);

  const blob = new Blob([svgContent], {
    type: "image/svg+xml",
  });

  svgElement.style.transform = transform;

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = "road-explorer-map.svg";
  link.href = url;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};

const search = ref("");

const logout = () => {
  authStore.logoutUser();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WorldMapSvg),
    _createElementVNode("div", {
      class: "absolute bottom-4 w-full w-full md:w-3/12 md:right-4",
      onClick: openStatsMenu
    }, [
      _createVNode(StatsButtonMenuContainer)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PaletteMenu)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(LeftButtonMenu, {
        class: "col-span-2 mx-auto",
        onClick: openFriendsMenu
      }),
      _createVNode(SearchButtonMenu, {
        class: "col-span-2 mx-auto",
        onClick: openSearchMenu
      }),
      _createVNode(ThemeButtonMenu, {
        class: "col-span-2 mx-auto",
        onClick: openThemeColorMenu
      })
    ]),
    _createVNode(BottomSheet, {
      "dialog-id": _unref(themeColorMenu),
      class: "h-auto",
      "all-draggable": false,
      "out-side-closable": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themes), (theme) => {
            return (_openBlock(), _createBlock(MapCaseForMenu, {
              key: theme.name,
              active: theme.name === themeSelected.value,
              color: theme.visited,
              "background-color": theme.background,
              onClick: ($event: any) => (updateThemeSelected(theme.name)),
              onTouch: ($event: any) => (updateThemeSelected(theme.name))
            }, null, 8, ["active", "color", "background-color", "onClick", "onTouch"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["dialog-id"]),
    _createVNode(BottomSheet, {
      "dialog-id": _unref(statsMenu),
      "all-draggable": false,
      "out-side-closable": true
    }, {
      default: _withCtx(() => [
        _createVNode(StatsButtonMenuContainer),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allContinents), (continent) => {
            return (_openBlock(), _createBlock(CountryListMenu, {
              key: continent,
              name: continent,
              dialogId: 
            dialogsContinent.find(
              (continentDialog) => continentDialog.continent === continent
            )?.dialog
          ,
              class: "mb-4"
            }, null, 8, ["name", "dialogId"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["dialog-id"]),
    _createVNode(SideBar, {
      "dialog-id": _unref(friendsMenu),
      "out-side-closable": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(UserManageViewContainer)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(UserAddViewContainer)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(UserNotificationsViewContainer)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ButtonPrimary, {
              onClick: downloadSvg,
              text: "Download SVG"
            }),
            _hoisted_11,
            _createVNode(ButtonSecondary, {
              onClick: logout,
              text: "Logout"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["dialog-id"]),
    _createVNode(BottomSheet, {
      "dialog-id": _unref(searchMenu),
      "all-draggable": false,
      "out-side-closable": true
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          name: "search",
          placeholder: "Search country",
          id: "search",
          is_required: "false",
          type: "text"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allContinents), (continent) => {
            return (_openBlock(), _createBlock(CountryListMenu, {
              key: continent,
              name: continent,
              dialogId: 
            dialogsContinent.find(
              (continentDialog) => continentDialog.continent === continent
            )?.dialog
          ,
              search: search.value,
              class: "mb-4"
            }, null, 8, ["name", "dialogId", "search"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["dialog-id"])
  ]))
}
}

})